/** Помошник, который обеспечивает отображение ADMS каталога  */
import { factory } from './Providers';
import { getValuesAsIs } from '../../virtuoso/helper';

import FieldStringType from '../widgets/fieldString'
import Unknown from '../widgets/unknown'
import {Concepts, Foaf, vCard, Language, ExternalLink, AssetLink, DefaultValue, FileDownload} from './AssetWidgets'

/** Возвращает наименование актива. Параметры:
 * 1. Массив с данным
 * 2. Язык
 * Возвращает массив значений либо данных, либо список предикатов
 */
export const getNameAsset = (values, lang) => {
  const predicates = factory.ui.getPredicateForName("http://www.w3.org/ns/adms#Asset");
  //console.log("getNameAsset", values, lang, predicates);
  const names = predicates.map(predicate =>  getValuesAsIs(predicate, lang, values));
  //console.log("getNameAsset2", names, names[0]);
  return (names.length>0)? names[0]:predicates;
}
/** Получение информации о наименование актива */
const components = {
    string: FieldStringType
  };
  
  //Возвращает react по его типу в XML описании.
  export const uiADMS = (subject) => {
      const component = components[subject]
      //console.log("ui begin");console.log(type);console.log(component);console.log(components);console.log("ui end");
      return (component==null)? Unknown: component;
  }
  

//Хранит по имени поля в adms_asset используемую компоненту отображения
const assetComponents = {
    dcat_theme: Concepts,
    dcterms_publisher: Foaf,
    dcat_contactPoint: vCard,
    dcterms_contributor: vCard,
    dcterms_creator: vCard,
    dcterms_language:Language,
    wdrs_describedby: ExternalLink,
    dcat_landingPage: ExternalLink,
    adms_last: AssetLink, adms_next: AssetLink, adms_prev: AssetLink, adms_sample: AssetLink, adms_translation: AssetLink,
    csi_disjunction: AssetLink, csi_equivalent: AssetLink, csi_extend: AssetLink, csi_generalize: AssetLink,
    csi_import: AssetLink, csi_metadata: AssetLink, csi_specialize: AssetLink,
    csi_domain: AssetLink, 
    dcat_distribution: FileDownload,
}

/** Фабрика, которая создаёт компоненты для представления свойств актива  */
export const uiAssetViewComponent = (subject) => {
    const component = assetComponents[subject];
    return (component==null)? DefaultValue: component;
}